import React, { Component } from 'react'
import Categories from './Categories/Categories';
import styles from './Menu.css';
import All from '../Menu/Categories/All/All';
import SideDrawer from '../../containers/SideDrawer/SideDrawer';
import OrderForm from '../../containers/OrderForm/OrderForm'

export default class Menu extends Component {
  state = { showSideDrawer: false }

  sideDrawerClosedHandler = () => {
    this.setState( { showSideDrawer: false } );
}

sideDrawerToggleHandler = () => {
    this.setState( ( prevState ) => {
        return { showSideDrawer: !prevState.showSideDrawer };
    } );
}


  render() {
    return (
      <div className={styles.menu}>
        <h1>Menu</h1>
        <Categories/>
        <button onClick={this.sideDrawerToggleHandler} 
        className={styles.catButton}>Categories</button>
        <SideDrawer  
        open={this.state.showSideDrawer}
        closed={this.sideDrawerClosedHandler}/>
        <All/>
        <h2 id='order'>Order</h2>
        <OrderForm/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js